import { Fragment, h } from 'preact';

import Newsletter from '../../newsletter/newsletter';
import { renderInPage } from '../../newsletter/renderers/render-newsletter-in-page';

import { renderModalTooltip } from './render-modal-tooltip';

export const renderNewsletter = ({ data, type, newslettersCtx, pageState, pageActions, pageHandlers, elementId }) => (
  <Fragment>
    <Newsletter
      htmlProps={data}
      widget={newslettersCtx.widget}
      state={newslettersCtx.state}
      actions={newslettersCtx.actions}
      render={renderInPage}
      pageActions={pageActions}
      blockInPageType={type}
      elementIdInPage={elementId}
      isActiveInPage={pageState.activeBlock === type}
    />
    {renderModalTooltip({
      modalTooltipData: data.modalTooltip,
      pageState,
      pageHandlers,
      htmlId: newslettersCtx.widget.htmlId,
    })}
  </Fragment>
);
